import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FormsStatus, GetPaidForms } from '@app/+payment/models/forms.enum';
import { HyperwalletKycCustomer } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-get-paid-reassurance',
  templateUrl: './get-paid-reassurance.component.html',
  styleUrls: ['./get-paid-reassurance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GetPaidReassuranceComponent implements OnInit {
  @Input()
  customerKYC: HyperwalletKycCustomer;
  @Input()
  selectedForm: GetPaidForms;
  @Input()
  userIsB2C: boolean;
  @Output()
  isSoleTrader = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  // If transfert method is done and verificationState is not required now
  get doneForNow() {
    return (
      this.customerKYC &&
      this.customerKYC.transferMethodState === FormsStatus.CONFIRMED &&
      this.customerKYC.verificationState === FormsStatus.NOT_REQUIRED
    );
  }

  // If all form are completed and validated
  get allDone() {
    return (
      this.customerKYC &&
      this.customerKYC.transferMethodState === FormsStatus.CONFIRMED &&
      this.customerKYC.verificationState === FormsStatus.VERIFIED
    );
  }

  get showInformationMessage() {
    return !this.allDone && !this.doneForNow;
  }
}
